import styled from "styled-components";
import { Modal } from "antd";
import { theme } from "../../styles/theme";

export const CustomModal = styled(Modal)`
    .ant-modal-content {
      border-radius: ${({ radius }) => radius || "28px"};
      font-family: ${theme.fonts.family};
      text-align: ${(props) => props.align || "center"};
      background: ${theme.colors.white} 0% 0% no-repeat padding-box;
      opacity: 1;
      width: ${(props) => (props.width ? props.width : "611px")};
      height: ${(props) => (props.height ? props.height : "413px")};
      padding: ${(props) => (props.padding ? props.padding : "43px 46px")};
    }

    .ant-modal-close {
      &:hover {
        background: transparent;
      }
      &-x {
        color: ${theme.colors.green};
      }
    }

    &-body {
      padding: ${(props) => props.padding};
    }
  }
`;
